<template>
  <div>
    <v-row>
      <v-col>
        <v-tabs
          v-model="userTab"
          show-arrows
          class="user-tabs"
          grow
          center-active
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>

          <v-tab
            :to="{ name: 'bots' }"
          >
            <v-icon
              color="error"
            >
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          id="user-tabs-content"
          v-model="userTab"
          class="mt-5"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loading"
              indeterminate
            ></v-progress-linear>
          </div>
          <v-tab-item>
            <bot-tab-add
              :chat-bot-id.sync="chatBotId"
            >
            </bot-tab-add>
          </v-tab-item>

          <v-tab-item>
            <bot-tab-arvore-config
              v-if="chatBotId"
              :chat-bot-id.sync="chatBotId"
              :arvore-id.sync="arvoreId"
            >
            </bot-tab-arvore-config>
          </v-tab-item>

          <v-tab-item>
            <bot-tab-templates
              v-if="chatBotId"
              :chat-bot-id.sync="chatBotId"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mdiRobotOutline, mdiCloseCircleOutline, mdiFileTreeOutline, mdiWhatsapp,
} from '@mdi/js'
import { onMounted, onBeforeMount, ref } from '@vue/composition-api'
import router from '@/router'
import { useRouter } from '@/@core/utils'
import BotTabAdd from '@/views/bot/BotTabAdd.vue'
import BotTabTemplates from '@/views/bot/BotTabTemplates.vue'
import BotTabArvoreConfig from '@/views/bot/BotTabArvoreConfig.vue'
import { EventBus } from '@/utils/EventBus'

export default {
  components: {
    BotTabAdd,
    BotTabArvoreConfig,
    BotTabTemplates,
  },

  setup() {
    function fecharMenuLateral() {
      EventBus.$emit('close-menu')
    }
    onMounted(fecharMenuLateral)

    const userData = ref({})
    const userTab = ref(0)
    const loading = ref(false)

    const chatBotId = ref(null)
    const arvoreId = ref(null)

    const { route } = useRouter()

    async function isIdChatBotDefined() {
      if (!route.value.fullPath.toLowerCase().includes('criar-bot')) {
        chatBotId.value = parseInt(router.currentRoute.params.id, 10)
      } else {
        chatBotId.value = 0
      }
    }

    onBeforeMount(async () => { await isIdChatBotDefined() })

    const tabs = [
      { icon: mdiRobotOutline, title: 'Configuração do ChatBot' },
      { icon: mdiFileTreeOutline, title: 'Configuração da Árvore' },
      { icon: mdiWhatsapp, title: 'Configuração dos templates' },
    ]

    return {
      tabs,
      chatBotId,
      arvoreId,
      userTab,
      userData,
      loading,
      isIdChatBotDefined,
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>

  <style lang="scss">
  .v-slide-group__content{
    display: flex;
    flex: 1 0 auto;
    position: relative;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    white-space: nowrap;
    justify-content: space-between;
  }
  @import '@core/preset/preset/apps/user.scss';

  </style>
